import { default as Title } from "./Title";

export const ProjectCell = { Title };
